import { Component, OnDestroy, OnInit } from '@angular/core';
import { HeaderTitleService } from 'src/app/modules/general/services/title.service';

@Component({
  selector: 'app-booking-event-area-item-slot-products',
  templateUrl: './booking-event-area-item-slot-products.component.html',
  styleUrls: ['./booking-event-area-item-slot-products.component.css']
})
export class BookingEventAreaItemSlotProductsComponent implements OnInit, OnDestroy {

  constructor(
    private headerTitleService: HeaderTitleService,
  ) { }

  ngOnInit() {
    this.headerTitleService.isVisibleTitle = true;
  }

  ngOnDestroy(): void {
    this.headerTitleService.isVisibleTitle = false;
  }

}
